// extracted by mini-css-extract-plugin
export default {"container":"PendingUploads_container__LQ0bg","fileContainer":"PendingUploads_fileContainer__ao3OA","file":"PendingUploads_file__Uyb4w","icon":"PendingUploads_icon__Wl3di"};